import React from "react";

// เมนูสำหรับครูผู้สอน

// Dashboard
import SchoolStatistic from "../dashboard/SchoolStatistic" // สถิติหลักของโรงเรียน
import TodayAttendanceDetail from "../dashboard/TodayAttendanceDetail" // รายชื่อ ขาด/สาย/ลา วันนี้ กดจากการ์ดหน้าแรก
import ExecutiveDashboard from "../executive/ExecutiveDashboard";
import ExecStudents from "../executive/ExecStudents";
import ExecAttendance from "../executive/ExecAttendance";
import ExecRisk from "../executive/ExecRisk";
import ExecDiscipline from "../executive/ExecDiscipline";
import ExecAcademic from "../executive/ExecAcademic";
import ExecStaff from "../executive/ExecStaff";
import ExecFinance from "../executive/ExecFinance";
import ExecDormitory from "../executive/ExecDormitory";
import ExecSupport from "../executive/ExecSupport";
import ExecMonthlyReport from "../executive/ExecMonthlyReport";

// General (ทั่วไป) — เข้าถึงได้ทุกคน
import GeneralDocuments from "../general/Documents";
import GeneralAnnouncements from "../general/Announcements";
import GeneralCalendar from "../general/Calendar";
import GeneralHelp from "../general/Help";

// Account (โปรไฟล์ / ตั้งค่าบัญชี) — เข้าถึงได้ทุกคนที่ล็อกอิน
import ProfileView from "../account/ProfileView";
import ProfileEdit from "../account/ProfileEdit";
import AccountSettings from "../account/AccountSettings";

// Issue Reporting (Form Do-style)
import IssueSubmit from "../issueReporting/IssueSubmit";
import IssueMyList from "../issueReporting/IssueMyList";
import IssueDetail from "../issueReporting/IssueDetail";
import IssueInbox from "../issueReporting/IssueInbox";
import IssueAdminCategories from "../issueReporting/IssueAdminCategories";
import IssueAdminDeptHeads from "../issueReporting/IssueAdminDeptHeads";

// Teaching
import SubjectClass from "../teaching/SubjectClass";
import MyTimetable from "../teaching/MyTimetable"; // ตารางสอนของฉัน
import TeacherTimetable from "../teaching/TeacherTimetable"; // ตารางสอนครู (ฝ่ายการเรียนการสอน)
import Attendance from "../teaching/Attendance"; // เช็คชื่อเข้าเรียน
import CheckAttendance from "../teaching/CheckAttendance"; // เช็คชื่อเข้าเรียน
import ManageAttendance from "../teaching/ManageAttendance";
import ListAttendance from "../teaching/ListAttendance"; // รายการเช็คชื่อเข้าเรียน
import AttendanceStatistic from "../teaching/AttendanceStatistic"; // สถิติการเข้าเรียน
import ListAttendanceStatistic from "../teaching/ListAttendanceStatistic"; //แสดงสถิติการเข้าเรียน
import EditAttendance from "../teaching/EditAttendance"; // แก้ไขการเช็คชื่อ
import SaveGrade from "../teaching/SaveGrade"; // บันทึกผลการเรียน (รายวิชา)
import GradeEntry from "../teaching/GradeEntry"; // บันทึกผลการเรียน (รายนักเรียน)
import ScoreTable from "../teaching/ScoreTable"; // ตารางคะแนน (ออกแบบ + กรอกคะแนนย่อย)
import ExamList from "../exam/ExamList"; // ข้อสอบและกระดาษคำตอบ
import ExamEditor from "../exam/ExamEditor";
import ExamDetail from "../exam/ExamDetail";
import ExamPrint from "../exam/ExamPrint";
import ExamScan from "../exam/ExamScan";
import ExamAbsenceCheck from "../examAbsence/ExamAbsenceCheck"; // เช็คนักเรียนขาดสอบ (ช่วงสอบ)
import ExamAbsenceSummary from "../examAbsence/ExamAbsenceSummary";
import ExamAbsentList from "../examAbsence/ExamAbsentList";
import Por5Assessment from "../teaching/Por5Assessment"; // ประเมินคุณลักษณะฯ/อ่านคิดวิเคราะห์ (ปพ.5)
import Por5Book from "../teaching/Por5Book"; // พิมพ์เล่ม ปพ.5
// import BehaviorRound from "../teaching/BehaviorRound"; // ปิดชั่วคราว: ประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
import SubjectCare from "../teaching/SubjectCare"; // การแจ้งดูแล/บันทึกการช่วยเหลือ (รายวิชา)
import MyCare from "../teaching/MyCare"; // ธงที่ฉันแจ้ง + นัดติดตามผลค้าง

// เมนูสำหรับที่ปรึกษาห้องเรียน
import AdvisorGrade from "../advisor/AdvisorGrade"; // ผลการเรียนรายวิชา
import ViewAdvisorGrade from "../advisor/ViewAdvisorGrade"; // แสดงผลการเรียนรายนักเรียน
import StudentGradeList from "../advisor/StudentGradeList"; // ผลการเรียนรายบุคคล (รายชื่อ)
import ViewStudentGrade from "../advisor/ViewStudentGrade"; // ผลการเรียนรายบุคคล (รายละเอียด)
import StudentDocument from "../advisor/StudentDocument";
import StudentInAdvice from "../advisor/StudentInAdvice";
import AdvisorDormitory from "../advisor/AdvisorDormitory";
import StudentInfo from "../advisor/StudentInfo";
import StudentPP6 from "../advisor/StudentPP6";
import DesirableEntry from "../advisor/DesirableEntry";
import StudentPP8 from "../advisor/StudentPP8";
import StudentBodyMass from "../advisor/StudentBodyMass";
import AdvisorTimetable from "../advisor/AdvisorTimetable"; // ตารางสอนห้องเรียน
import AdvisorClassGrade from "../advisor/AdvisorClassGrade"; // เกรดรวมในชั้นเรียน (auto-redirect)
import StudentHealth from "../advisor/StudentHealth"; // บันทึกสุขภาพนักเรียน
import AdvisorDashboard from "../advisor/AdvisorDashboard"; // Dashboard ภาพรวมห้องเรียน
import GuidanceAttendance from "../advisor/GuidanceAttendance"; // คาบแนะแนว (ภาพรวม/ประวัติ)
import GuidanceCheck from "../advisor/GuidanceCheck"; // เช็คชื่อคาบแนะแนว
import GuidanceEditAttendance from "../advisor/GuidanceEditAttendance"; // แก้ไขเช็คชื่อคาบแนะแนว
import GuidanceTracking from "../guidance/GuidanceTracking"; // งานแนะแนว — ติดตามการเข้าคาบแนะแนวรายห้อง
import StudentLeave from "../advisor/StudentLeave"; // แจ้งลานักเรียน
import AdvisorTalent from "../advisor/AdvisorTalent"; // จุดเด่นทางวิชาการ (เฉพาะห้องที่ปรึกษา)

// เมนูสำหรับผู้ดูแลการสอน
import TimetableEditor from "../teaching/TimetableEditor"; // ตารางสอน
import ManagePeriod from "../teaching/ManagePeriod"; // จัดการคาบเรียน
import ManageTeaching from "../teaching/ManageTeaching"; // จัดการข้อมูลการสอน
import SubstituteAssign from "../teaching/SubstituteAssign"; // มอบหมายครูสอนแทน
import SubstituteArrangement from "../teaching/SubstituteArrangement"; // จัดครูสอนแทน (ครูลา) — ฝ่ายการเรียนการสอน
import SubstituteOverview from "../teaching/SubstituteOverview"; // ภาพรวม/สรุปการสอนแทน
import TeachingTracking from "../teaching/TeachingTracking"; // ติดตามการสอน
import ListTeachingTracking from "../teaching/ListTeachingTracking"; // บันทึกการสอนรายวิชา
import ClubManagement from "../clubs/ClubManagement";
import MyClubs from "../clubs/MyClubs";
import ClubWorkspace from "../clubs/ClubWorkspace";
import ClubAttendanceReport from "../clubs/ClubAttendanceReport";

// เมนูสำหรับฝ่ายวัดผลและประเมินผล
import AllClassGrade from "../assessment/AllClassGrade";
import ViewClassGrade from "../assessment/ViewClassGrade";
import StudentsGrades from "../assessment/StudentsGrades";
import MakeupExamRequest from "../assessment/MakeupExamRequest";
import GradeDistributionReport from "../assessment/GradeDistributionReport";
import AssessmentSettings from "../assessment/AssessmentSettings"; // ตั้งค่างานวัดผล (วันสิ้นสุดการส่งเกรด ฯลฯ)

// เมนูสำหรับหัวหน้าวิชาการสามัญ
import GeneralAttendanceReport from "../reports/GeneralAttendanceReport"; // หัวหน้าวิชาการสามัญ
import AttendanceReportHistory from "../reports/AttendanceReportHistory"; // รายงานการเข้าเรียนย้อนหลัง
import StudentGradeReview from "../academic/StudentGradeReview";
import GradeSubmissionReport from "../reports/GradeSubmissionReport"; // รายงานการส่งเกรด
import AssignmentSubmissionReport from "../reports/AssignmentSubmissionReport"; // รายงานการส่งงาน
import AttendanceTrackingStudent from "../reports/AttendanceTrackingStudent"; // ติดตามการเข้าเรียนรายนักเรียน
import AttendanceByRoom from "../reports/AttendanceByRoom"; // การเข้าเรียน/บันทึกการสอน รายห้องเรียน
import SubjectAttendanceTracking from "../reports/SubjectAttendanceTracking"; // ติดตามขาดเรียนรายวิชา
import TeachingRecordByTeacher from "../reports/TeachingRecordByTeacher"; // บันทึกการสอนรายครู
import TeachersOnLeave from "../reports/TeachersOnLeave"; // ครูลา / การจัดสอนแทน
import StudentListByRoom from "../reports/StudentListByRoom"; // รายชื่อนักเรียนรายห้อง
import StudentInfoView from "../reports/StudentInfoView"; // ข้อมูลนักเรียน (อ่านอย่างเดียว)
import AdvisorTaskTracking from "../reports/AdvisorTaskTracking"; // ติดตามงานครูประจำชั้น
import StudentsOnLeave from "../reports/StudentsOnLeave"; // นักเรียนที่ลา (รายงาน อ่านอย่างเดียว)
import AcademicStudentLeave from "../reports/AcademicStudentLeave"; // แจ้งลานักเรียน (หัวหน้าวิชาการสามัญ)
import StudentTracking from "../reports/StudentTracking"; // ระบบติดตามนักเรียน / Early Warning
import StudentTrackingDetail from "../reports/StudentTrackingDetail"; // เจาะรายคน (ติดตามนักเรียน)
import CareTracking from "../reports/CareTracking"; // ติดตามการดูแลนักเรียน (checklist ขั้นตอนดูแล — หัวหน้าระดับ)
import StudentTalentReport from "../reports/StudentTalentReport"; // จุดเด่นด้านการเรียน (Talent / radar)
import TeachingEntryMonitor from "../reports/TeachingEntryMonitor"; // ติดตามการเข้าสอน (คาบ 5-10)

// เมนูสำหรับทะเบียนและหลักสูตร
import ManageClass from "../registration/ManageClass"; // ห้องเรียน
import ManageCurriculum from "../registration/ManageCurriculum";
import ManageStudents from "../registration/ManageStudents"; // นักเรียน
import ManageSubjects from "../registration/ManageSubject"; // วิชา
import StudentExit from "../registration/StudentExit"; // จำหน่ายนักเรียน / สำเร็จการศึกษา
import EditStudentInfo from "../registration/EditStudentInfo"; // ค้นหาและแก้ไขข้อมูลนักเรียน

// เมนูสำหรับงานรับสมัคร (เดิมเป็นโปรเจคแยก reg.wti.ac.th)
import AdmissionDashboard from "../admission/AdmissionDashboard";
import AdmissionRegister from "../admission/AdmissionRegister";
import AdmissionList from "../admission/AdmissionList";
import AdmissionEdit from "../admission/AdmissionEdit";
import AdmissionPrint from "../admission/AdmissionPrint";
import AdmissionRegisterBook from "../admission/AdmissionRegisterBook";

// เมนูสำหรับห้องสมุด
import LibraryHome from "../library/LibraryHome";
import LibraryCirculation from "../library/LibraryCirculation";
import LibraryAcquisition from "../library/LibraryAcquisition";
import LibraryBarcodeLabels from "../library/LibraryBarcodeLabels";
import LibraryMasterData from "../library/LibraryMasterData";
import LibraryBookManagement from "../library/LibraryBookManagement";
import LibraryRenewals from "../library/LibraryRenewals";
import LibraryReservations from "../library/LibraryReservations";
import LibraryFines from "../library/LibraryFines";
import LibraryBookSearch from "../library/LibraryBookSearch";

// เมนูสำหรับหอพัก
import DormitoryHome from "../dormitory/DormitoryHome";
import DormitoryVillages from "../dormitory/DormitoryVillages";
import DormitoryBuildings from "../dormitory/DormitoryBuildings";
import DormitoryAllocation from "../dormitory/DormitoryAllocation";
import DormitoryTransfer from "../dormitory/DormitoryTransfer";
import DormitoryVacancy from "../dormitory/DormitoryVacancy";
import DormitoryStudentSearch from "../dormitory/DormitoryStudentSearch";
import DormitoryClearance from "../dormitory/DormitoryClearance";
import DormitoryClearanceDetail from "../dormitory/DormitoryClearanceDetail";
import ClearanceDoc from "../dormitory/print/ClearanceDoc";
import NightCheck from "../dormitory/NightCheck";                             // ครูเวรเดินเช็คชื่อทีละหลังหลังอีซา
import NightCheckReport from "../dormitory/NightCheckReport";                 // รายงานเช็คชื่อหอก่อนนอน
import DisciplineDormTeachers from "../discipline/DisciplineDormTeachers";   // หัวหน้าฝ่ายปกครองมอบหมายครูหอพักรายเขต
import Whereabouts from "../safety/Whereabouts";                           // ตอนนี้เด็กคนนี้อยู่ที่ไหน
import Emergency from "../safety/Emergency";                               // ประกาศเหตุฉุกเฉิน + นับยอดที่จุดรวมพล
// เมนูการเงิน / ค่าใช้จ่ายนักเรียน
import FeeHome from "../fee/FeeHome";
import FeeItems from "../fee/FeeItems";
import FeeTerms from "../fee/FeeTerms";
import FeePlans from "../fee/FeePlans";
import FeeDormFees from "../fee/FeeDormFees";
import FeeInvoices from "../fee/FeeInvoices";
import FeeInvoiceDetail from "../fee/FeeInvoiceDetail";
// เมนูงานบุคลากร (HR)
import HrDashboard from "../hr/HrDashboard";
import HrStaffList from "../hr/HrStaffList";
import HrStaffDetail from "../hr/HrStaffDetail";
import HrLeaveTypes from "../hr/HrLeaveTypes";
import HrLeaveApproval from "../hr/HrLeaveApproval";
import HrOffsiteApproval from "../hr/HrOffsiteApproval";
import HrTrainingApproval from "../hr/HrTrainingApproval";
import HrLeaveReport from "../hr/HrLeaveReport";
import HrTeachingAttendance from "../hr/HrTeachingAttendance";
import MyHrProfile from "../hr/MyHrProfile";
import LeaveFormDoc from "../hr/print/LeaveFormDoc";
import MyLeave from "../hr/MyLeave";
import MyOffsite from "../hr/MyOffsite";
import MyTraining from "../hr/MyTraining";
import TeachersOnTraining from "../reports/TeachersOnTraining"; // ครูไปอบรม/ประชุม (หัวหน้าวิชาการ)
// เมนูงานธุรการ (Admin Office)
// ห้องพยาบาล (pos 28 + เจ้าหน้าที่หอพัก 17)
import NurseDashboard from "../nurse/NurseDashboard";
import NurseVisit from "../nurse/NurseVisit";
import NurseVisitList from "../nurse/NurseVisitList";
import NurseStudentFile from "../nurse/NurseStudentFile";
import NurseSymptoms from "../nurse/NurseSymptoms";
import NurseMedicines from "../nurse/NurseMedicines";
import NurseCheckup from "../nurse/NurseCheckup";
import NurseVaccine from "../nurse/NurseVaccine";
import NurseReports from "../nurse/NurseReports";
import ReferralDoc from "../nurse/print/ReferralDoc";

import IncomingDocs from "../adminOffice/IncomingDocs";
import IncomingDocDetail from "../adminOffice/IncomingDocDetail";
import OutgoingDocs from "../adminOffice/OutgoingDocs";
import OutgoingDocPrint from "../adminOffice/OutgoingDocPrint";
import MyReceivedDocs from "../adminOffice/MyReceivedDocs";
import MyMemos from "../adminOffice/MyMemos";
import MemoScreening from "../adminOffice/MemoScreening";
import ExecMemoInbox from "../adminOffice/ExecMemoInbox";
import MemoPrint from "../adminOffice/MemoPrint";
import OrdersRegistry from "../adminOffice/OrdersRegistry";
import OrderDetail from "../adminOffice/OrderDetail";
import MyOrders from "../adminOffice/MyOrders";
import ResourceManage from "../adminOffice/ResourceManage";
import BookingApproval from "../adminOffice/BookingApproval";
import MyBooking from "../adminOffice/MyBooking";
import BookingCalendar from "../adminOffice/BookingCalendar";
import AoDashboard from "../adminOffice/AoDashboard";
import Archive from "../adminOffice/Archive";
import DailyLog from "../adminOffice/DailyLog";
import DailyLogPrint from "../adminOffice/DailyLogPrint";
import Projects from "../adminOffice/Projects";
import ProjectDetail from "../adminOffice/ProjectDetail";
import MyProjects from "../adminOffice/MyProjects";
import AnnualSummary from "../adminOffice/AnnualSummary";
import CertificateRegistry from "../adminOffice/CertificateRegistry";
import CertificatePrint from "../adminOffice/CertificatePrint";
import WorkCalendar from "../adminOffice/WorkCalendar";
import Meetings from "../adminOffice/Meetings";
import MeetingDetail from "../adminOffice/MeetingDetail";
import MeetingPrint from "../adminOffice/MeetingPrint";
import ResolutionTracking from "../adminOffice/ResolutionTracking";
import MyMeetings from "../adminOffice/MyMeetings";
import DisciplineAbsenceMonitor from "../discipline/DisciplineAbsenceMonitor";
import StudentAttendanceIndividual from "../discipline/StudentAttendanceIndividual"; // การเข้าเรียนรายบุคคล (ภาคศาสนา/ภาคสามัญ)
import DisciplineConduct from "../discipline/DisciplineConduct";
import DisciplineConductRules from "../discipline/DisciplineConductRules";
import DisciplineMerit from "../discipline/DisciplineMerit";                 // จิตอาสาเพิ่มคะแนนความประพฤติ
import DisciplineMeritActivities from "../discipline/DisciplineMeritActivities";
import DisciplineLowConduct from "../discipline/DisciplineLowConduct";
import DisciplineHomeLeave from "../discipline/DisciplineHomeLeave";
import DisciplineHomeLeaveStats from "../discipline/DisciplineHomeLeaveStats";
import DisciplineStudentLeave from "../discipline/DisciplineStudentLeave";
import DisciplineOuting from "../discipline/DisciplineOuting";
import GuardGatePass from "../guard/GuardGatePass";
import GuardGateScan from "../guard/GuardGateScan";                          // แตะบัตร RFID ที่ประตู
import DisciplineGateScanLog from "../discipline/DisciplineGateScanLog";      // ประวัติการแตะบัตร — ตรวจย้อนหลังว่าใครยืนยัน
import AdminRfidCards from "../admin/AdminRfidCards";                        // ผูกบัตร RFID กับนักเรียน/ครู
import AdminPrayerDevices from "../admin/AdminPrayerDevices";
import AdminGateDevices from "../admin/AdminGateDevices";                    // ทะเบียนประตู + กล่องอ่านบัตร/จอที่ป้อมยาม

// เช็คชื่อละหมาด 5 เวลา (นักเรียนหอพัก)
import PrayerScan from "../prayer/PrayerScan";                               // ครูเวรถือมือถือแตะบัตรที่ทางออกแถว
import PrayerCorrection from "../prayer/PrayerCorrection";                   // แก้ผลรายคนเมื่อมีข้อยกเว้น (ไม่ใช่งานประจำวัน)
import PrayerTimes from "../prayer/PrayerTimes";                             // แก้เวลาละหมาดให้ตรงปฏิทินโรงเรียน
import PrayerReport from "../prayer/PrayerReport";                           // สถิติ: แนวโน้มรายวัน + คนที่ขาดบ่อย
import PrayerSettings from "../prayer/PrayerSettings";                       // หน้าต่างรับแตะบัตรของแต่ละเวลา
import AdminMonitorDevices from "../admin/AdminMonitorDevices";              // ทะเบียนจอมอนิเตอร์สุขภาพระบบบนโต๊ะผู้ดูแล
// Admin
import AdminStaff       from "../admin/AdminStaff";
import AdminUsageStats  from "../admin/AdminUsageStats";
import AdminAuditLog    from "../admin/AdminAuditLog";
import AdminPermissions from "../admin/AdminPermissions";
import AdminPositions   from "../admin/AdminPositions";
import AdminSettings    from "../admin/AdminSettings";

import BankDashboard     from "../bank/BankDashboard";
import InventoryDashboard from "../inventory/InventoryDashboard";
import InventoryAssets from "../inventory/InventoryAssets";
import InventoryProcurement from "../inventory/InventoryProcurement";
import InventoryVendors from "../inventory/InventoryVendors";
import InventorySettings from "../inventory/InventorySettings";
import SupplyDashboard from "../supply/SupplyDashboard";
import SupplyItems from "../supply/SupplyItems";
import SupplyReceive from "../supply/SupplyReceive";
import SupplyRequisitions from "../supply/SupplyRequisitions";
import SupplyBorrow from "../supply/SupplyBorrow";
import SupplySettings from "../supply/SupplySettings";

// Islamic Education — Registration
import ManageIslamicRoom       from "../islamic-registration/ManageIslamicRoom";
import ManageIslamicCurriculum from "../islamic-registration/ManageIslamicCurriculum";
import ManageIslamicSubject    from "../islamic-registration/ManageIslamicSubject";
import ManageIslamicStudents   from "../islamic-registration/ManageIslamicStudents";
import UpdateIslamicStudent    from "../islamic-registration/UpdateIslamicStudent";

// Islamic Education — Teaching
import IslamicSubjectList      from "../islamic-teaching/IslamicSubjectList";
import IslamicMyTimetable      from "../islamic-teaching/IslamicMyTimetable";
import IslamicAttendancePage   from "../islamic-teaching/IslamicAttendancePage";
import IslamicCheckAttendance  from "../islamic-teaching/IslamicCheckAttendance";
import IslamicEditAttendance   from "../islamic-teaching/IslamicEditAttendance";
import IslamicAttendanceStatistic from "../islamic-teaching/IslamicAttendanceStatistic";
import IslamicScoreEntry       from "../islamic-teaching/IslamicScoreEntry";
import IslamicManageTeaching      from "../islamic-teaching/IslamicManageTeaching";
import IslamicTimetableEditor    from "../islamic-teaching/IslamicTimetableEditor";
import IslamicTeacherTimetable   from "../islamic-teaching/IslamicTeacherTimetable";
import IslamicTeachingTracking    from "../islamic-teaching/IslamicTeachingTracking";
import IslamicListTeachTracking   from "../islamic-teaching/IslamicListTeachTracking";

// Islamic Education — Assessment
import IslamicClassGrade       from "../islamic-assessment/IslamicClassGrade";

// Islamic Education — Advisor
import IslamicAdvisorHome      from "../islamic-advisor/IslamicAdvisorHome";
import IslamicAdvisorStudents  from "../islamic-advisor/IslamicAdvisorStudents";
import IslamicAdvisorTimetable from "../islamic-advisor/IslamicAdvisorTimetable";
import IslamicAdvisorDormitory from "../islamic-advisor/IslamicAdvisorDormitory";
import IslamicAdvisorLeave     from "../islamic-advisor/IslamicAdvisorLeave";
import IslamicAdvisorGrade     from "../islamic-advisor/IslamicAdvisorGrade";

// Islamic student tracking (ระบบติดตามนักเรียน + ติดตามการดูแลนักเรียน ภาคศาสนา)
import IslamicStudentTracking       from "../islamic-tracking/IslamicStudentTracking";
import IslamicStudentTrackingDetail from "../islamic-tracking/IslamicStudentTrackingDetail";
import IslamicCareTracking          from "../islamic-tracking/IslamicCareTracking";

// Islamic academic head (รายงาน/ติดตามทั้งภาคศาสนา — หัวหน้าวิชาการศาสนา pos 57)
import IslamicAbsenceMonitor        from "../islamic-academic/IslamicAbsenceMonitor";
import IslamicAttendanceReport      from "../islamic-academic/IslamicAttendanceReport";
import IslamicAttendanceIndividual  from "../islamic-academic/IslamicAttendanceIndividual";
import IslamicStudentsOnLeave       from "../islamic-academic/IslamicStudentsOnLeave";
import IslamicStudentListByRoom     from "../islamic-academic/IslamicStudentListByRoom";
import IslamicAdvisorTasks          from "../islamic-academic/IslamicAdvisorTasks";
import BankAccounts      from "../bank/BankAccounts";
import BankTransactions  from "../bank/BankTransactions";
import BankAccountDetail from "../bank/BankAccountDetail";

import EventManagement from "../dashboard/EventManagement";
import SalesMonitoring from "../dashboard/SalesMonitoring";
import WebsiteAnalytics from "../dashboard/WebsiteAnalytics";
import FinanceMonitoring from "../dashboard/FinanceMonitoring";
import Cryptocurrency from "../dashboard/Cryptocurrency";
import HelpdeskService from "../dashboard/HelpdeskService";
import StorageManagement from "../dashboard/StorageManagement";
import ProductManagement from "../dashboard/ProductManagement";

// Students
import StudentInClass from "../students/StudentInClass"; // นักเรียนในห้องเรียน
import StudentSearch from "../students/StudentSearch"; // ค้นหาข้อมูลนักเรียน

// Apps
import GalleryMusic from "../apps/GalleryMusic";
import GalleryVideo from "../apps/GalleryVideo";
import Tasks from "../apps/Tasks";
import Contacts from "../apps/Contacts";
import Chat from "../apps/Chat";
import AppCalendar from "../apps/AppCalendar";
import Email from "../apps/Email";
import FileManager from "../apps/FileManager";

// Pages
import Pricing from "../pages/Pricing";
import Faq from "../pages/Faq";
import Profile from "../pages/Profile";
import ChangePassword from "../components/ChangePassword";
import People from "../pages/People";
import Activity from "../pages/Activity";
import Events from "../pages/Events";
import Settings from "../pages/Settings";

// UI Elements
import LayoutColumns from "../docs/LayoutColumns";
import LayoutGrid from "../docs/LayoutGrid";
import LayoutGutters from "../docs/LayoutGutters";
import Accordions from "../docs/Accordions";
import Alerts from "../docs/Alerts";
import Avatars from "../docs/Avatars";
import Badges from "../docs/Badges";
import Breadcrumbs from "../docs/Breadcrumbs";
import Buttons from "../docs/Buttons";
import Cards from "../docs/Cards";
import Carousels from "../docs/Carousels";
import Dropdowns from "../docs/Dropdowns";
import Images from "../docs/Images";
import Listgroup from "../docs/Listgroup";
import Markers from "../docs/Markers";
import Modals from "../docs/Modals";
import NavTabs from "../docs/NavTabs";
import OffCanvas from "../docs/OffCanvas";
import Paginations from "../docs/Paginations";
import Placeholders from "../docs/Placeholders";
import Popovers from "../docs/Popovers";
import Progress from "../docs/Progress";
import Spinners from "../docs/Spinners";
import Toasts from "../docs/Toasts";
import Tooltips from "../docs/Tooltips";
import Tables from "../docs/Tables";
import FormElements from "../docs/FormElements";
import FormSelects from "../docs/FormSelects";
import FormChecksRadios from "../docs/FormChecksRadios";
import FormRange from "../docs/FormRange";
import FormPickers from "../docs/FormPickers";
import FormLayouts from "../docs/FormLayouts";
import UtilBackground from "../docs/UtilBackground";
import UtilBorder from "../docs/UtilBorder";
import UtilColors from "../docs/UtilColors";
import UtilDivider from "../docs/UtilDivider";
import UtilFlex from "../docs/UtilFlex";
import UtilSizing from "../docs/UtilSizing";
import UtilSpacing from "../docs/UtilSpacing";
import UtilOpacity from "../docs/UtilOpacity";
import UtilPosition from "../docs/UtilPosition";
import UtilTypography from "../docs/UtilTypography";
import UtilShadows from "../docs/UtilShadows";
import UtilExtras from "../docs/UtilExtras";
import ApexCharts from "../docs/ApexCharts";
import ChartJs from "../docs/ChartJs";
import MapLeaflet from "../docs/MapLeaflet";
import MapVector from "../docs/MapVector";
import IconRemix from "../docs/IconRemix";
import IconFeather from "../docs/IconFeather";

const protectedRoutes = [
  { path: "dashboard/school-statistic", element: <SchoolStatistic /> },
  { path: "dashboard/today-attendance", element: <TodayAttendanceDetail section="general" /> },
  // การ์ดภาคศาสนาบนหน้าแรกโชว์ให้เฉพาะกลุ่มนี้ หน้ารายละเอียดจึงจำกัดชุดเดียวกัน
  { path: "dashboard/today-attendance-islamic", element: <TodayAttendanceDetail section="islamic" />, requiredPositions: [50, 51, 52, 53, 99] },
  { path: "executive/dashboard", element: <ExecutiveDashboard />, requiredPositions: [90, 99] },
  // ตัวเลขและสถิติของผู้บริหาร — อ่านอย่างเดียวทุกหน้า ไม่มี POST ในกลุ่มนี้
  { path: "executive/students", element: <ExecStudents />, requiredPositions: [90, 99] },
  { path: "executive/attendance", element: <ExecAttendance />, requiredPositions: [90, 99] },
  { path: "executive/risk", element: <ExecRisk />, requiredPositions: [90, 99] },
  { path: "executive/discipline", element: <ExecDiscipline />, requiredPositions: [90, 99] },
  { path: "executive/academic", element: <ExecAcademic />, requiredPositions: [90, 99] },
  { path: "executive/staff", element: <ExecStaff />, requiredPositions: [90, 99] },
  { path: "executive/finance", element: <ExecFinance />, requiredPositions: [90, 99] },
  { path: "executive/dormitory", element: <ExecDormitory />, requiredPositions: [90, 99] },
  { path: "executive/support", element: <ExecSupport />, requiredPositions: [90, 99] },
  { path: "executive/monthly-report", element: <ExecMonthlyReport />, requiredPositions: [90, 99] },

  // เมนูสำหรับครูผู้สอน
  { path: "teaching/subject-class", element: <SubjectClass />, requiredPositions: [1] }, // ข้อมูลการสอน
  { path: "teaching/my-timetable", element: <MyTimetable />, requiredPositions: [1] }, // ตารางสอนของฉัน
  { path: "students/search", element: <StudentSearch /> }, // ค้นหาข้อมูลนักเรียน — ทุกคนเข้าถึงได้
  { path: "students/student-in-class/:r_id/:c_class/:r_no", element: <StudentInClass />, requiredPositions: [1] }, // นักเรียนในห้องเรียน
  { path: "teaching/attendance", element: <Attendance />, requiredPositions: [1] }, // เช็คชื่อเข้าเรียน
  { path: "teaching/substitute", element: <SubstituteAssign />, requiredPositions: [1, 2, 5, 99] }, // มอบหมายครูสอนแทน
  { path: "teaching/substitute-arrangement", element: <SubstituteArrangement />, requiredPositions: [5, 99] }, // จัดครูสอนแทน (ครูลา) — ฝ่ายการเรียนการสอน
  // { path: "teaching/check-attendance/:r_id/:teach_id/:period", element: <CheckAttendance />, requiredPositions: [1] }, // เช็คชื่อเข้าเรียน
  { path: "teaching/check-attendance/:r_id/:teach_id", element: <CheckAttendance />, requiredPositions: [1] }, // เช็คชื่อเข้าเรียน
  { path: "teaching/manage-attendance/", element: <ManageAttendance />, requiredPositions: [1] }, // จัดการข้อมูลการเช็คชื่อ
  { path: "teaching/list-attendance/:teach_id", element: <ListAttendance />, requiredPositions: [1] }, // รายการเช็คชื่อเข้าเรียน
  { path: "teaching/attendance-statistic", element: <AttendanceStatistic />, requiredPositions: [1] }, // สถิติการเข้าเรียน
  { path: "teaching/list-attendance-statistic/:teach_id", element: <ListAttendanceStatistic />, requiredPositions: [1] }, // แสดงสถิติการเข้าเรียน
  { path: "teaching/edit-attendance/:teach_id/:att_date/:period_id", element: <EditAttendance />, requiredPositions: [1] }, // แก้ไขการเช็คชื่อ
  { path: "teaching/saveGrade", element: <SaveGrade />, requiredPositions: [1] }, // บันทึกผลการเรียน (รายวิชา)
  { path: "teaching/grade-entry/:teach_id", element: <GradeEntry />, requiredPositions: [1] }, // บันทึกผลการเรียน (รายนักเรียน)
  { path: "teaching/score-table/:teach_id", element: <ScoreTable />, requiredPositions: [1, 99] }, // ตารางคะแนน (ออกแบบ + กรอกคะแนนย่อย)
  { path: "teaching/exams", element: <ExamList />, requiredPositions: [1, 99] }, // ข้อสอบและกระดาษคำตอบ
  { path: "teaching/exams/new", element: <ExamEditor />, requiredPositions: [1, 99] },
  { path: "teaching/exams/:examId", element: <ExamDetail />, requiredPositions: [1, 99] },
  { path: "teaching/exams/:examId/edit", element: <ExamEditor />, requiredPositions: [1, 99] },
  { path: "teaching/exams/:examId/print/:teachId", element: <ExamPrint />, requiredPositions: [1, 99] }, // พิมพ์กระดาษคำตอบรายคน
  { path: "teaching/exams/:examId/scan", element: <ExamScan />, requiredPositions: [1, 99] }, // สแกนกระดาษคำตอบ (กล้อง/PDF/รูป หน้าเดียว)
  { path: "teaching/exams/:examId/camera", element: <ExamScan initialMode="camera" />, requiredPositions: [1, 99] }, // ลิงก์เดิม — เปิดหน้าเดียวกันในโหมดกล้อง
  { path: "teaching/por5-assessment/:teach_id", element: <Por5Assessment />, requiredPositions: [1, 99] }, // ประเมินคุณลักษณะฯ/อ่านคิดวิเคราะห์ (ปพ.5)
  { path: "teaching/por5-book/:teach_id", element: <Por5Book />, requiredPositions: [1, 99] }, // พิมพ์เล่ม ปพ.5
  // ปิดชั่วคราว: ประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
  // { path: "teaching/behavior-assessment/:teach_id", element: <BehaviorRound />, requiredPositions: [1, 99] }, // ประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
  { path: "teaching/subject-care/:teach_id", element: <SubjectCare />, requiredPositions: [1, 99] }, // การแจ้งดูแล/บันทึกการช่วยเหลือ (รายวิชา)
  { path: "teaching/my-care", element: <MyCare />, requiredPositions: [1, 99] }, // ธงที่ฉันแจ้ง + นัดติดตามผลค้าง

  // เมนูสำหรับที่ปรึกษาห้องเรียน
  { path: "advisor/dashboard", element: <AdvisorDashboard />, requiredPositions: [2, 99] }, // Dashboard ภาพรวมห้องเรียน
  { path: "advisor/grade", element: <AdvisorGrade />, requiredPositions: [2] }, // ผลการเรียนรายวิชา
  { path: "advisor/view-grade/:teach_id", element: <ViewAdvisorGrade />, requiredPositions: [2] }, // แสดงผลการเรียนรายนักเรียน
  { path: "advisor/student-document", element: <StudentDocument />, requiredPositions: [2] }, // รายชื่อนักเรียนในห้องเรียน
  { path: "advisor/student-in-advice", element: <StudentInAdvice />, requiredPositions: [2] }, // รายชื่อนักเรียนในห้องเรียน
  { path: "advisor/dormitory", element: <AdvisorDormitory />, requiredPositions: [2, 99] }, // จัดนักเรียนห้องประจำชั้นเข้าหอพัก
  { path: "advisor/student-info/:studentID", element: <StudentInfo />, requiredPositions: [2, 8, 9, 99] }, // ข้อมูลนักเรียน
  { path: "advisor/student-pp-6/:studentID", element: <StudentPP6 />, requiredPositions: [2] }, // ข้อมูลนักเรียน
  { path: "advisor/desirable", element: <DesirableEntry />, requiredPositions: [2] }, // คุณลักษณะอันพึงประสงค์
  { path: "advisor/student-pp-8/:studentID", element: <StudentPP8 />, requiredPositions: [2] }, // ระเบียนสะสม ปพ.8
  { path: "advisor/student-body-mass", element: <StudentBodyMass />, requiredPositions: [2] }, // บันทึกส่วนสูงและน้ำหนัก
  { path: "advisor/timetable", element: <AdvisorTimetable />, requiredPositions: [2] }, // ตารางสอนห้องเรียน
  { path: "advisor/class-grade", element: <AdvisorClassGrade />, requiredPositions: [2] }, // เกรดรวมในชั้นเรียน (advisor)
  { path: "advisor/student-grade", element: <StudentGradeList />, requiredPositions: [2] }, // ผลการเรียนรายบุคคล
  { path: "advisor/student-grade/:study_id/:year_id", element: <ViewStudentGrade />, requiredPositions: [2] }, // รายละเอียดผลการเรียน
  { path: "advisor/student-health", element: <StudentHealth />, requiredPositions: [2] }, // บันทึกสุขภาพนักเรียน
  { path: "advisor/guidance", element: <GuidanceAttendance />, requiredPositions: [2] }, // คาบแนะแนว (ภาพรวม/ประวัติ)
  { path: "advisor/guidance-check/:guid_id", element: <GuidanceCheck />, requiredPositions: [2] }, // เช็คชื่อคาบแนะแนว
  { path: "advisor/guidance-edit/:guid_id/:att_date", element: <GuidanceEditAttendance />, requiredPositions: [2] }, // แก้ไขเช็คชื่อคาบแนะแนว

  // งานแนะแนว (pos 7)
  { path: "guidance/tracking", element: <GuidanceTracking />, requiredPositions: [7, 99] }, // ติดตามการเข้าคาบแนะแนวรายห้อง (อ่านอย่างเดียว)
  { path: "advisor/student-leave", element: <StudentLeave />, requiredPositions: [2, 99] }, // แจ้งลานักเรียน
  { path: "advisor/talent", element: <AdvisorTalent />, requiredPositions: [2, 99] }, // จุดเด่นทางวิชาการ (เฉพาะห้องที่ปรึกษา)

  // เมนูสำหรับผู้ดูแลการสอน
  { path: "teaching/manage-period", element: <ManagePeriod />, requiredPositions: [5, 99] },
  { path: "teaching/teacher-timetable", element: <TeacherTimetable />, requiredPositions: [5, 99] }, // ดูตารางสอนของครูรายคน
  { path: "teaching/timetable-editor", element: <TimetableEditor />, requiredPositions: [5, 99] },
  { path: "teaching/timetable-editor/:c_id", element: <TimetableEditor />, requiredPositions: [5, 99] },
  { path: "teaching/manage-teaching", element: <ManageTeaching />, requiredPositions: [5, 99] }, // จัดการข้อมูลการสอน
  { path: "teaching/manage-teaching/:c_id", element: <ManageTeaching />, requiredPositions: [5, 99] }, // จัดการข้อมูลการสอน
  { path: "teaching/teaching-tracking", element: <TeachingTracking />, requiredPositions: [5, 99] }, // ติดตามการสอน
  { path: "teaching/teaching-tracking/:c_id", element: <TeachingTracking />, requiredPositions: [5, 99] }, // ติดตามการสอน
  { path: "teaching/list-teaching-tracking/:teach_id", element: <ListTeachingTracking />, requiredPositions: [5, 99] }, // บันทึกการสอนรายวิชา
  { path: "clubs/manage", element: <ClubManagement />, requiredPositions: [5, 99] }, // จัดการชุมนุม
  { path: "clubs/my", element: <MyClubs />, requiredPositions: [1, 5, 99] }, // ชุมนุมของฉัน
  { path: "clubs/my/:clubYearId", element: <ClubWorkspace />, requiredPositions: [1, 5, 99] }, // เช็คชื่อ/ประเมินชุมนุม
  { path: "academic/club-attendance", element: <ClubAttendanceReport />, requiredPositions: [3, 4, 99] }, // สถิติการเข้าชุมนุม (หัวหน้าวิชาการสามัญ อ่านอย่างเดียว)

  // เมนูสำหรับทะเบียนและหลักสูตร
  { path: "registration/manage-classes", element: <ManageClass />, requiredPositions: [8, 9, 99] }, // จัดการห้องเรียน
  { path: "registration/manage-classes/:c_id", element: <ManageClass />, requiredPositions: [8, 9, 99] }, // จัดการห้องเรียน
  { path: "registration/manage-curriculum", element: <ManageCurriculum />, requiredPositions: [8, 9, 99] }, // จัดการหลักสูตร
  { path: "registration/manage-students/:c_id", element: <ManageStudents />, requiredPositions: [8, 9, 29, 99] }, // จัดการนักเรียน (งานระบบ PSIS 29 ด้วย)
  { path: "registration/manage-subjects", element: <ManageSubjects />, requiredPositions: [8, 9, 99] }, // จัดการวิชา
  { path: "registration/student-exit", element: <StudentExit />, requiredPositions: [8, 9, 29, 99] }, // จำหน่ายนักเรียน / สำเร็จการศึกษา
  { path: "registration/edit-student", element: <EditStudentInfo />, requiredPositions: [8, 9, 29, 99] }, // ค้นหาและแก้ไขข้อมูลนักเรียน

  // เมนูสำหรับงานรับสมัคร — ต้นทางของนักเรียนทุกคน ก่อนถูกจัดเข้าห้องที่ manage-students
  { path: "admission/dashboard", element: <AdmissionDashboard />, requiredPositions: [8, 9, 90, 99] }, // ภาพรวมงานรับสมัคร
  { path: "admission/register", element: <AdmissionRegister />, requiredPositions: [8, 9, 90, 99] }, // รับสมัครนักเรียน
  { path: "admission/applicants", element: <AdmissionList />, requiredPositions: [8, 9, 90, 99] }, // รายชื่อผู้สมัคร
  { path: "admission/edit/:st_id", element: <AdmissionEdit />, requiredPositions: [8, 9, 90, 99] }, // แก้ไขข้อมูลผู้สมัคร
  { path: "admission/print/:st_id", element: <AdmissionPrint />, requiredPositions: [8, 9, 90, 99] }, // ใบสมัคร + ใบมอบตัว
  { path: "admission/register-book", element: <AdmissionRegisterBook />, requiredPositions: [8, 9, 90, 99] }, // ทะเบียนนักเรียนใหม่ (ทะเบียนใหญ่)

  // เมนูสำหรับห้องสมุด
  { path: "library/home", element: <LibraryHome />, requiredPositions: [13, 99] }, // หน้าแรกห้องสมุด
  { path: "library/acquisition", element: <LibraryAcquisition />, requiredPositions: [13, 99] }, // นำเข้าหนังสือ
  { path: "library/barcode-labels", element: <LibraryBarcodeLabels />, requiredPositions: [13, 99] }, // สร้างและพิมพ์ป้ายรหัสเล่ม
  { path: "library/circulation", element: <LibraryCirculation />, requiredPositions: [13, 99] }, // งานยืม-คืนหนังสือ
  { path: "library/master-data", element: <LibraryMasterData />, requiredPositions: [13, 99] }, // จัดการข้อมูลแม่บทห้องสมุด
  { path: "library/book-management", element: <LibraryBookManagement />, requiredPositions: [13, 99] }, // จัดการข้อมูลหนังสือและเล่ม
  { path: "library/renewals", element: <LibraryRenewals />, requiredPositions: [13, 99] }, // งานต่ออายุการยืม
  { path: "library/reservations", element: <LibraryReservations />, requiredPositions: [13, 99] }, // งานจองหนังสือ
  { path: "library/fines", element: <LibraryFines />, requiredPositions: [13, 99] }, // งานค่าปรับห้องสมุด
  { path: "library/book-search", element: <LibraryBookSearch />, requiredPositions: [13, 99] }, // ค้นหาหนังสือ

  // เมนูสำหรับหอพัก (admin only - role 99 and 17)
  { path: "dormitory/home", element: <DormitoryHome />, requiredPositions: [99, 17] },
  { path: "dormitory/villages", element: <DormitoryVillages />, requiredPositions: [99, 17] },
  { path: "dormitory/buildings", element: <DormitoryBuildings />, requiredPositions: [99, 17] },
  { path: "dormitory/allocation", element: <DormitoryAllocation />, requiredPositions: [99, 17] },
  { path: "dormitory/transfer", element: <DormitoryTransfer />, requiredPositions: [99, 17] },
  { path: "dormitory/vacancy", element: <DormitoryVacancy />, requiredPositions: [99, 17] },
  { path: "dormitory/student-search", element: <DormitoryStudentSearch />, requiredPositions: [99, 17] },
  // ใบคืนหอพัก — หน้ารายการ/เปิดใบ, ตัวใบ, และใบที่สั่งพิมพ์สำหรับเซ็น
  { path: "dormitory/clearance", element: <DormitoryClearance />, requiredPositions: [99, 17] },
  { path: "dormitory/clearance/:dcId", element: <DormitoryClearanceDetail />, requiredPositions: [99, 17] },
  { path: "dormitory/clearance/:dcId/print", element: <ClearanceDoc />, requiredPositions: [99, 17] },
  // เช็คขาดสอบ — ครูทุกคนเข้าได้ ไม่กำหนด requiredPositions; server ล็อกเองเมื่อไม่อยู่ในช่วงสอบ
  // (examAbsenceController) ส่วนสองหน้าหลังต้องตรงกับ managerPositions ของทั้งสองภาค / ABSENT_VIEW_POSITIONS
  { path: "exam-absence/check", element: <ExamAbsenceCheck /> },
  { path: "exam-absence/summary", element: <ExamAbsenceSummary />, requiredPositions: [3, 4, 10, 11, 52, 57, 99] },
  { path: "exam-absence/absent", element: <ExamAbsentList />, requiredPositions: [3, 4, 10, 11, 16, 27, 52, 57, 99] },
  // เช็คชื่อหอก่อนนอน — ไม่กำหนด requiredPositions เพราะครูหอพักเป็นครูทั่วไปที่ไม่มีตำแหน่ง
  // สิทธิ์มาจากการถูกหัวหน้าฝ่ายปกครองมอบหมายเขต ซึ่ง server ตรวจเอง (requireNightAccess)
  // และหน้าจอบอกเองเมื่อยังไม่ได้รับมอบหมาย ส่วนรายงานต้องตรงกับ nightReport ใน dormitoryRoute.js
  { path: "dormitory/night-check", element: <NightCheck /> },
  { path: "dormitory/night-check/report", element: <NightCheckReport />, requiredPositions: [99, 27, 90] },
  { path: "discipline/dorm-teachers", element: <DisciplineDormTeachers />, requiredPositions: [99, 27] },
  // ความปลอดภัย — ไม่กำหนด requiredPositions: ตอนนี้อยู่ที่ไหนเปิดให้บุคลากรทุกคน ส่วนเหตุฉุกเฉิน
  // ครูหอพักไม่มีตำแหน่ง server ตรวจสิทธิ์เอง (safetyController.js) และหน้าจอบอกเองเมื่อไม่มีสิทธิ์
  { path: "safety/whereabouts", element: <Whereabouts /> },
  { path: "safety/emergency", element: <Emergency /> },

  // เมนูการเงิน / ค่าใช้จ่ายนักเรียน (finance role 25, admin 99)
  { path: "fee/home", element: <FeeHome />, requiredPositions: [25, 99] },
  { path: "fee/items", element: <FeeItems />, requiredPositions: [25, 99] },
  { path: "fee/terms", element: <FeeTerms />, requiredPositions: [25, 99] },
  { path: "fee/plans", element: <FeePlans />, requiredPositions: [25, 99] },
  { path: "fee/dormitory", element: <FeeDormFees />, requiredPositions: [25, 99] },
  { path: "fee/invoices", element: <FeeInvoices />, requiredPositions: [25, 99] },
  { path: "fee/invoices/:invoiceId", element: <FeeInvoiceDetail />, requiredPositions: [25, 99] },

  // เมนูงานบุคลากร (HR role 20, หัวหน้าบุคลากร 26, admin 99)
  // หน้า leave-approval / offsite-approval เปิดให้ 20 ดูรายการได้ แต่ปุ่มอนุมัติเป็นของ 26/99 เท่านั้น (บังคับที่ server)
  { path: "hr/dashboard", element: <HrDashboard />, requiredPositions: [20, 26, 99] },
  { path: "hr/staff", element: <HrStaffList />, requiredPositions: [20, 26, 99] },
  { path: "hr/staff/:tId", element: <HrStaffDetail />, requiredPositions: [20, 26, 99] },
  { path: "hr/leave-types", element: <HrLeaveTypes />, requiredPositions: [20, 26, 99] },
  { path: "hr/leave-approval", element: <HrLeaveApproval />, requiredPositions: [20, 26, 99] },
  { path: "hr/offsite-approval", element: <HrOffsiteApproval />, requiredPositions: [20, 26, 99] },
  // หัวหน้าวิชาการสามัญ (3, 4) อนุมัติได้ด้วย — คนที่ต้องจัดสอนแทนคาบที่ครูไม่อยู่
  // ต้องตรงกับ trainingApprovalAccess ใน server/routes/hrRoute.js
  { path: "hr/training-approval", element: <HrTrainingApproval />, requiredPositions: [3, 4, 20, 26, 99] },
  { path: "hr/leave-report", element: <HrLeaveReport />, requiredPositions: [20, 26, 99] },
  { path: "hr/teaching-attendance", element: <HrTeachingAttendance />, requiredPositions: [3, 4, 20, 26, 99] },

  // ห้องพยาบาล — พยาบาล (28) + เจ้าหน้าที่หอพัก (17) บันทึกได้, ตั้งค่าเป็นของพยาบาล
  { path: "nurse/dashboard", element: <NurseDashboard />, requiredPositions: [17, 28, 99] },
  { path: "nurse/visit", element: <NurseVisit />, requiredPositions: [17, 28, 99] },
  { path: "nurse/visits", element: <NurseVisitList />, requiredPositions: [17, 28, 99] },
  { path: "nurse/visits/:nvId/referral", element: <ReferralDoc />, requiredPositions: [17, 28, 99] },
  { path: "nurse/students/:stId", element: <NurseStudentFile />, requiredPositions: [17, 28, 99] },
  { path: "nurse/medicines", element: <NurseMedicines />, requiredPositions: [17, 28, 99] },
  { path: "nurse/reports", element: <NurseReports />, requiredPositions: [17, 28, 99] },
  // ตรวจสุขภาพ วัคซีน และตั้งค่า เป็นของพยาบาล (server บังคับด้วย nurseOnly)
  { path: "nurse/checkup", element: <NurseCheckup />, requiredPositions: [28, 99] },
  { path: "nurse/vaccine", element: <NurseVaccine />, requiredPositions: [28, 99] },
  { path: "nurse/symptoms", element: <NurseSymptoms />, requiredPositions: [28, 99] },

  // เมนูงานธุรการ (Admin Office role 23, admin 99)
  { path: "admin-office/dashboard", element: <AoDashboard />, requiredPositions: [23, 99] },
  { path: "admin-office/archive", element: <Archive />, requiredPositions: [23, 99] },
  { path: "admin-office/incoming", element: <IncomingDocs />, requiredPositions: [23, 99] },
  { path: "admin-office/incoming/:inId", element: <IncomingDocDetail />, requiredPositions: [23, 99] },
  { path: "admin-office/outgoing", element: <OutgoingDocs />, requiredPositions: [23, 99] },
  { path: "admin-office/outgoing/:outId/print", element: <OutgoingDocPrint />, requiredPositions: [23, 99] },
  { path: "admin-office/memos", element: <MemoScreening />, requiredPositions: [23, 99] },
  { path: "admin-office/orders", element: <OrdersRegistry />, requiredPositions: [23, 99] },
  { path: "admin-office/orders/:odId", element: <OrderDetail />, requiredPositions: [23, 99] },
  { path: "admin-office/resources", element: <ResourceManage />, requiredPositions: [23, 99] },
  { path: "admin-office/booking-approval", element: <BookingApproval />, requiredPositions: [23, 99] },
  { path: "admin-office/meetings", element: <Meetings />, requiredPositions: [23, 99] },
  { path: "admin-office/meetings/:mtId", element: <MeetingDetail />, requiredPositions: [23, 99] },
  { path: "admin-office/meetings/:mtId/print-invite", element: <MeetingPrint mode="invite" />, requiredPositions: [23, 99] },
  { path: "admin-office/meetings/:mtId/print-report", element: <MeetingPrint mode="report" />, requiredPositions: [23, 99] },
  { path: "admin-office/resolutions", element: <ResolutionTracking />, requiredPositions: [23, 99] },
  { path: "admin-office/daily-log", element: <DailyLog />, requiredPositions: [23, 90, 99] },
  { path: "admin-office/daily-log/print", element: <DailyLogPrint />, requiredPositions: [23, 90, 99] },
  { path: "admin-office/projects", element: <Projects />, requiredPositions: [23, 99] },
  { path: "admin-office/projects/:pjId", element: <ProjectDetail /> }, // ธุรการ + เจ้าของโครงการ — สิทธิ์ตรวจฝั่ง server
  { path: "admin-office/annual-summary", element: <AnnualSummary />, requiredPositions: [23, 99] },
  { path: "admin-office/certificates", element: <CertificateRegistry />, requiredPositions: [23, 99] },
  { path: "admin-office/certificates/:ctId/print", element: <CertificatePrint />, requiredPositions: [23, 99] },
  { path: "admin-office/work-calendar", element: <WorkCalendar />, requiredPositions: [23, 99] },
  { path: "exec/memos", element: <ExecMemoInbox />, requiredPositions: [90, 99] },

  // เมนูงานวินัยและปกครอง (Discipline role 16, admin 99)
  // ฝ่ายปกครอง — หัวหน้า (27) ได้ทุกหน้า สารวัตรนักเรียน (16) ได้เฉพาะงานติดตาม/ความประพฤติ
  // ต้องตรงกับ disciplineRoute.js ฝั่ง server (ดูหัว "สิทธิ์ของฝ่ายปกครอง" ใน disciplineController.js)
  { path: "discipline/absence-monitor", element: <DisciplineAbsenceMonitor />, requiredPositions: [3, 16, 27, 99] },
  { path: "discipline/individual-attendance", element: <StudentAttendanceIndividual />, requiredPositions: [16, 27, 99] }, // การเข้าเรียนรายบุคคล — 2 แท็บ ภาคศาสนา/ภาคสามัญ
  { path: "discipline/conduct", element: <DisciplineConduct />, requiredPositions: [16, 27, 99] },
  { path: "discipline/conduct-rules", element: <DisciplineConductRules />, requiredPositions: [27, 99] },
  { path: "discipline/merit", element: <DisciplineMerit />, requiredPositions: [16, 27, 99] },                       // จิตอาสา — เพิ่มคะแนนความประพฤติ
  { path: "discipline/merit-activities", element: <DisciplineMeritActivities />, requiredPositions: [27, 99] },
  { path: "discipline/low-conduct", element: <DisciplineLowConduct />, requiredPositions: [16, 27, 99] },
  // อนุญาตกลับบ้าน/ออกนอก — ไม่กำหนด requiredPositions เพราะครูหอพักไม่มีตำแหน่ง ได้สิทธิ์จาก
  // การถูกมอบหมายเขต server กรองเหลือเฉพาะนักเรียนในเขตนั้น (requireLeaveAccess)
  { path: "discipline/home-leave", element: <DisciplineHomeLeave /> },
  { path: "discipline/home-leave-stats", element: <DisciplineHomeLeaveStats />, requiredPositions: [27, 99] }, // สถิติการกลับบ้าน — รายบุคคล + ภาพรวม
  { path: "discipline/student-leave", element: <DisciplineStudentLeave />, requiredPositions: [16, 27, 99] },
  { path: "discipline/outing", element: <DisciplineOuting /> },
  { path: "discipline/gate-scan-log", element: <DisciplineGateScanLog />, requiredPositions: [27, 99] }, // ยามแตะบัตรได้ แต่การตรวจย้อนหลังเป็นงานหัวหน้าฝ่ายปกครอง

  // จุดตรวจประตูโรงเรียน (รปภ./ยาม 24, ฝ่ายปกครอง 16, admin 99)
  { path: "guard/gate-pass", element: <GuardGatePass />, requiredPositions: [24, 27, 99] },
  { path: "guard/gate-scan", element: <GuardGateScan />, requiredPositions: [24, 27, 99] },   // แตะบัตรแทนการค้นชื่อ
  { path: "admin/rfid-cards", element: <AdminRfidCards />, requiredPositions: [99] },
  { path: "admin/gate-devices", element: <AdminGateDevices />, requiredPositions: [99] },
  { path: "admin/prayer-devices", element: <AdminPrayerDevices />, requiredPositions: [99] },   // จอที่มัสยิด ออกโทเคนประจำเครื่อง

  // เช็คชื่อละหมาด — ครูเวรหอ (17) ฝ่ายปกครอง (16) และครูศาสนา (50, 51)
  // ซึ่งเป็นคนคุมแถวซุฮ์รี/อัสรีที่อยู่ในเวลาเรียน ต้องตรงกับ prayerRoute.js ฝั่ง server
  { path: "prayer/scan", element: <PrayerScan />, requiredPositions: [16, 17, 50, 51, 99] },
  { path: "prayer/correction", element: <PrayerCorrection />, requiredPositions: [16, 17, 50, 51, 99] },
  { path: "prayer/times", element: <PrayerTimes />, requiredPositions: [17, 50, 99] },
  // สถิติเปิดกว้างกว่าหน้าทำงาน: หัวหน้าวิชาการศาสนา (57) และผู้บริหาร (90) ดูได้แต่ติ๊กไม่ได้
  { path: "prayer/report", element: <PrayerReport />, requiredPositions: [16, 17, 50, 51, 57, 90, 99] },
  { path: "prayer/settings", element: <PrayerSettings />, requiredPositions: [17, 50, 99] },
  { path: "admin/monitor-devices", element: <AdminMonitorDevices />, requiredPositions: [99] },

  // Admin (pos 99 only)
  { path: "admin/staff",       element: <AdminStaff />,       requiredPositions: [99] },
  { path: "admin/permissions", element: <AdminPermissions />, requiredPositions: [99] },
  { path: "admin/positions",   element: <AdminPositions />,   requiredPositions: [99] },
  { path: "admin/settings",    element: <AdminSettings />,    requiredPositions: [99] },
  { path: "admin/usage-stats", element: <AdminUsageStats />,  requiredPositions: [99] },
  { path: "admin/audit-log",   element: <AdminAuditLog />,    requiredPositions: [99] },

  { path: "bank/dashboard",    element: <BankDashboard />,     requiredPositions: [18, 99] },
  { path: "bank/accounts",     element: <BankAccounts />,      requiredPositions: [18, 99] },
  { path: "bank/transactions", element: <BankTransactions />,  requiredPositions: [18, 99] },
  { path: "bank/account/:id",  element: <BankAccountDetail />, requiredPositions: [18, 99] },

  // เมนูงานพัสดุครุภัณฑ์
  { path: "inventory/dashboard",   element: <InventoryDashboard />,   requiredPositions: [19, 23, 99] },
  { path: "inventory/assets",      element: <InventoryAssets />,      requiredPositions: [19, 23, 99] },
  { path: "inventory/procurement", element: <InventoryProcurement />, requiredPositions: [19, 23, 99] },
  { path: "inventory/vendors",     element: <InventoryVendors />,     requiredPositions: [19, 23, 99] },
  { path: "inventory/settings",    element: <InventorySettings />,    requiredPositions: [19, 23, 99] },

  // เมนูวัสดุและของใช้
  { path: "supply/dashboard",      element: <SupplyDashboard />,      requiredPositions: [19, 23, 99] },
  { path: "supply/items",          element: <SupplyItems />,          requiredPositions: [19, 23, 99] },
  { path: "supply/receive",        element: <SupplyReceive />,        requiredPositions: [19, 23, 99] },
  { path: "supply/requisitions",   element: <SupplyRequisitions />,   requiredPositions: [19, 23, 99] },
  { path: "supply/borrow",         element: <SupplyBorrow />,         requiredPositions: [19, 23, 99] },
  { path: "supply/settings",       element: <SupplySettings />,       requiredPositions: [19, 23, 99] },

  // เมนูสำหรับฝ่ายวัดผลและประเมินผล
  { path: "assessment/all-class-grade", element: <AllClassGrade />, requiredPositions: [8, 9, 10, 11, 99] },
  { path: "assessment/class-grade/:room_id/:year_id", element: <ViewClassGrade />, requiredPositions: [2, 8, 9, 10, 11, 99] },
  { path: "assessment/student-grades", element: <StudentsGrades />, requiredPositions: [10, 11, 99] },
  { path: "assessment/makeup-exam-request", element: <MakeupExamRequest />, requiredPositions: [10, 11, 99] },
  { path: "assessment/grade-distribution", element: <GradeDistributionReport />, requiredPositions: [10, 11, 99] },
  { path: "assessment/settings", element: <AssessmentSettings />, requiredPositions: [10, 11, 99] }, // ตั้งค่างานวัดผล

  // เมนูสำหรับหัวหน้าวิชาการสามัญ
  { path: "academic/general-attendance-report", element: <GeneralAttendanceReport />, requiredPositions: [3, 4, 21, 22, 99] }, // หัวหน้าวิชาการสามัญ + หัวหน้าระดับ ม.ต้น/ม.ปลาย (ข้อมูลกรองตามระดับที่ backend)
  { path: "academic/attendance-history-report", element: <AttendanceReportHistory />, requiredPositions: [3, 4, 21, 22, 99] }, // รายงานการเข้าเรียนย้อนหลัง
  { path: "academic/student-grade-review", element: <StudentGradeReview />, requiredPositions: [3, 4, 8, 9, 99] }, // ตรวจสอบผลการเรียนรายบุคคล
  { path: "academic/grade-submission-report", element: <GradeSubmissionReport />, requiredPositions: [3, 4, 99] }, // รายงานการส่งเกรด
  { path: "academic/assignment-submission-report", element: <AssignmentSubmissionReport />, requiredPositions: [3, 4, 99] }, // รายงานการส่งงาน
  { path: "academic/attendance-tracking", element: <AttendanceTrackingStudent />, requiredPositions: [3, 4, 21, 22, 99] }, // ติดตามการเข้าเรียนรายนักเรียน / กลุ่มเสี่ยง
  { path: "academic/subject-attendance-tracking", element: <SubjectAttendanceTracking />, requiredPositions: [2, 3, 4, 21, 22, 99] }, // ติดตามขาดเรียนรายวิชา (กรองด้วยเกณฑ์ขาดขั้นต่ำ) — ครูประจำชั้นเห็นเฉพาะห้องตน
  { path: "academic/attendance-by-room", element: <AttendanceByRoom />, requiredPositions: [3, 4, 99] }, // การเข้าเรียน/บันทึกการสอน รายห้อง
  { path: "academic/teaching-entry-monitor", element: <TeachingEntryMonitor />, requiredPositions: [3, 4, 99] }, // ติดตามการเข้าสอน (คาบ 5-10)
  { path: "academic/teaching-records-by-teacher", element: <TeachingRecordByTeacher />, requiredPositions: [3, 4, 99] }, // บันทึกการสอนรายครู
  { path: "academic/substitute-overview", element: <SubstituteOverview />, requiredPositions: [3, 4, 5, 99] }, // ภาพรวม/สรุปการสอนแทน
  { path: "academic/teachers-on-leave", element: <TeachersOnLeave />, requiredPositions: [3, 4, 16, 20, 27, 99] }, // ครูลา / การจัดสอนแทน (รายงาน อ่านอย่างเดียว)
  { path: "academic/teachers-on-training", element: <TeachersOnTraining />, requiredPositions: [3, 4, 20, 99] }, // ครูไปอบรม/ประชุม (รายงาน อ่านอย่างเดียว)
  { path: "academic/student-list-by-room", element: <StudentListByRoom />, requiredPositions: [3, 4, 7, 21, 22, 99] }, // รายชื่อนักเรียนรายห้อง (งานแนะแนว pos 7 ใช้ร่วม)
  { path: "academic/student-info/:studentID", element: <StudentInfoView />, requiredPositions: [3, 4, 99] }, // ข้อมูลนักเรียน (อ่านอย่างเดียว)
  { path: "islamic/advisor/student-info/:studentID", element: <UpdateIslamicStudent />, requiredPositions: [51, 99] }, // ข้อมูลนักเรียน (ที่ปรึกษาศาสนา แก้ไขได้)
  { path: "academic/advisor-task-tracking", element: <AdvisorTaskTracking />, requiredPositions: [3, 4, 99] }, // ติดตามงานครูประจำชั้น
  { path: "academic/students-on-leave", element: <StudentsOnLeave />, requiredPositions: [3, 4, 21, 22, 99] }, // นักเรียนที่ลา (รายงาน อ่านอย่างเดียว)
  { path: "academic/student-leave", element: <AcademicStudentLeave />, requiredPositions: [3, 4, 99] }, // แจ้งลานักเรียน (บันทึกเป็น "หัวหน้าวิชาการแจ้ง")
  { path: "academic/student-tracking", element: <StudentTracking />, requiredPositions: [2, 3, 4, 16, 21, 22, 27, 99] }, // ระบบติดตามนักเรียน / Early Warning
  { path: "academic/student-tracking/:studentID", element: <StudentTrackingDetail />, requiredPositions: [2, 3, 4, 16, 21, 22, 27, 99] }, // เจาะรายคน (ติดตามนักเรียน)
  { path: "academic/care-tracking", element: <CareTracking />, requiredPositions: [2, 3, 4, 21, 22, 99] }, // ติดตามการดูแลนักเรียน — checklist ขั้นตอนดูแลตามเกณฑ์ (ครูประจำชั้นเห็นเฉพาะห้องตน / หัวหน้าระดับ / หัวหน้าวิชาการดูอย่างเดียว)
  { path: "academic/student-talent", element: <StudentTalentReport />, requiredPositions: [3, 4, 99] }, // จุดเด่นด้านการเรียน (radar)

  // เมนูบุคลากร self-service — เข้าถึงได้ทุกคนที่ล็อกอิน
  { path: "hr/my-profile", element: <MyHrProfile /> },
  { path: "hr/my-leave",   element: <MyLeave /> },
  { path: "hr/leave/:lrId/print", element: <LeaveFormDoc /> }, // แบบใบลา — สิทธิ์ตรวจฝั่ง server (เจ้าของใบ/ฝ่ายบุคลากร)
  { path: "hr/my-offsite", element: <MyOffsite /> },
  { path: "hr/my-training", element: <MyTraining /> },

  // เมนูงานธุรการ self-service — เข้าถึงได้ทุกคนที่ล็อกอิน
  { path: "my/received-docs", element: <MyReceivedDocs /> },
  { path: "my/memos", element: <MyMemos /> },
  { path: "my/memos/:mmId/print", element: <MemoPrint /> }, // สิทธิ์ตรวจฝั่ง server (เจ้าของ/ธุรการ/ผู้บริหาร)
  { path: "my/orders", element: <MyOrders /> },
  { path: "my/booking", element: <MyBooking /> },
  { path: "booking-calendar", element: <BookingCalendar /> },
  { path: "my/meetings", element: <MyMeetings /> },
  { path: "my/projects", element: <MyProjects /> },

  // เมนูทั่วไป — เข้าถึงได้ทุกคนที่ล็อกอิน (ไม่ใส่ requiredPositions)
  { path: "general/documents",     element: <GeneralDocuments /> },
  { path: "general/announcements", element: <GeneralAnnouncements /> },
  { path: "general/calendar",      element: <GeneralCalendar /> },
  { path: "general/help",          element: <GeneralHelp /> },

  // เมนูบัญชีผู้ใช้ — เข้าถึงได้ทุกคนที่ล็อกอิน
  { path: "account/profile",       element: <ProfileView /> },
  { path: "account/profile/edit",  element: <ProfileEdit /> },
  { path: "account/settings",      element: <AccountSettings /> },

  // Issue Reporting — ทุก staff แจ้งและดูรายการตนเองได้
  { path: "issues/submit",            element: <IssueSubmit /> },
  { path: "issues/mine",              element: <IssueMyList /> },
  { path: "issues/detail/:ir_id",     element: <IssueDetail /> },
  // Inbox: เปิดให้ทุก staff เห็น URL ได้ แต่ API จะ 403 ถ้าไม่ใช่หัวหน้าฝ่าย/admin
  { path: "issues/inbox",             element: <IssueInbox /> },
  // Admin: pos 99
  { path: "issues/admin/categories",  element: <IssueAdminCategories />, requiredPositions: [99] },
  { path: "issues/admin/dept-heads",  element: <IssueAdminDeptHeads />,  requiredPositions: [99] },

  // เมนูเดิมจาก template
  { path: "dashboard/finance", element: <FinanceMonitoring /> },
  { path: "dashboard/events", element: <EventManagement /> },
  { path: "dashboard/sales", element: <SalesMonitoring /> },
  { path: "dashboard/analytics", element: <WebsiteAnalytics /> },
  { path: "dashboard/crypto", element: <Cryptocurrency /> },
  { path: "dashboard/helpdesk", element: <HelpdeskService /> },
  { path: "dashboard/storage", element: <StorageManagement /> },
  { path: "dashboard/product", element: <ProductManagement /> },
  { path: "apps/gallery-music", element: <GalleryMusic /> },
  { path: "apps/gallery-video", element: <GalleryVideo /> },
  { path: "apps/tasks", element: <Tasks /> },
  { path: "apps/contacts", element: <Contacts /> },
  { path: "apps/chat", element: <Chat /> },
  { path: "apps/calendar", element: <AppCalendar /> },
  { path: "apps/email", element: <Email /> },
  { path: "apps/file-manager", element: <FileManager /> },
  { path: "pages/pricing", element: <Pricing /> },
  { path: "pages/faq", element: <Faq /> },
  { path: "pages/profile", element: <Profile /> },
  { path: "pages/change-password", element: <ChangePassword /> },
  { path: "pages/people", element: <People /> },
  { path: "pages/activity", element: <Activity /> },
  { path: "pages/events", element: <Events /> },
  { path: "pages/settings", element: <Settings /> },
  { path: "docs/layout/grid", element: <LayoutGrid /> },
  { path: "docs/layout/columns", element: <LayoutColumns /> },
  { path: "docs/layout/gutters", element: <LayoutGutters /> },
  { path: "docs/com/accordions", element: <Accordions /> },
  { path: "docs/com/alerts", element: <Alerts /> },
  { path: "docs/com/avatars", element: <Avatars /> },
  { path: "docs/com/badge", element: <Badges /> },
  { path: "docs/com/breadcrumbs", element: <Breadcrumbs /> },
  { path: "docs/com/buttons", element: <Buttons /> },
  { path: "docs/com/cards", element: <Cards /> },
  { path: "docs/com/carousel", element: <Carousels /> },
  { path: "docs/com/dropdown", element: <Dropdowns /> },
  { path: "docs/com/images", element: <Images /> },
  { path: "docs/com/listgroup", element: <Listgroup /> },
  { path: "docs/com/markers", element: <Markers /> },
  { path: "docs/com/modal", element: <Modals /> },
  { path: "docs/com/navtabs", element: <NavTabs /> },
  { path: "docs/com/offcanvas", element: <OffCanvas /> },
  { path: "docs/com/pagination", element: <Paginations /> },
  { path: "docs/com/placeholders", element: <Placeholders /> },
  { path: "docs/com/popovers", element: <Popovers /> },
  { path: "docs/com/progress", element: <Progress /> },
  { path: "docs/com/spinners", element: <Spinners /> },
  { path: "docs/com/toasts", element: <Toasts /> },
  { path: "docs/com/tooltips", element: <Tooltips /> },
  { path: "docs/com/tables", element: <Tables /> },
  { path: "docs/form/elements", element: <FormElements /> },
  { path: "docs/form/selects", element: <FormSelects /> },
  { path: "docs/form/checksradios", element: <FormChecksRadios /> },
  { path: "docs/form/range", element: <FormRange /> },
  { path: "docs/form/pickers", element: <FormPickers /> },
  { path: "docs/form/layouts", element: <FormLayouts /> },
  { path: "docs/chart/apex", element: <ApexCharts /> },
  { path: "docs/chart/chartjs", element: <ChartJs /> },
  { path: "docs/map/leaflet", element: <MapLeaflet /> },
  { path: "docs/map/vector", element: <MapVector /> },
  { path: "docs/icon/remix", element: <IconRemix /> },
  { path: "docs/icon/feather", element: <IconFeather /> },
  { path: "docs/util/background", element: <UtilBackground /> },
  { path: "docs/util/border", element: <UtilBorder /> },
  { path: "docs/util/colors", element: <UtilColors /> },
  { path: "docs/util/divider", element: <UtilDivider /> },
  { path: "docs/util/flex", element: <UtilFlex /> },
  { path: "docs/util/sizing", element: <UtilSizing /> },
  { path: "docs/util/spacing", element: <UtilSpacing /> },
  { path: "docs/util/opacity", element: <UtilOpacity /> },
  { path: "docs/util/position", element: <UtilPosition /> },
  { path: "docs/util/typography", element: <UtilTypography /> },
  { path: "docs/util/shadows", element: <UtilShadows /> },
  { path: "docs/util/extras", element: <UtilExtras /> }
]

// Islamic Education routes — rendered under IslamicLayout (RTL)
export const islamicProtectedRoutes = [
  // Registration (pos 52, 99)
  { path: "islamic/manage-rooms",                  element: <ManageIslamicRoom />,       requiredPositions: [52, 99] },
  { path: "islamic/manage-curriculum",             element: <ManageIslamicCurriculum />, requiredPositions: [52, 99] },
  { path: "islamic/manage-subjects/:isa_id",       element: <ManageIslamicSubject />,    requiredPositions: [52, 99] },
  { path: "islamic/manage-students/:ir_id",        element: <ManageIslamicStudents />,   requiredPositions: [52, 99] },
  { path: "islamic/update-student/:studentID",     element: <UpdateIslamicStudent />,    requiredPositions: [52, 99] },

  // Teaching — teacher view (pos 50, 99)
  { path: "islamic/my-subjects",                         element: <IslamicSubjectList />,      requiredPositions: [50, 99] },
  { path: "islamic/my-timetable",                        element: <IslamicMyTimetable />,      requiredPositions: [50, 99] },
  { path: "islamic/attendance",                          element: <IslamicAttendancePage />,   requiredPositions: [50, 99] },
  { path: "islamic/check-attendance/:ir_id/:is_teachId", element: <IslamicCheckAttendance />,  requiredPositions: [50, 99] },
  { path: "islamic/edit-attendance/:is_teachId/:date/:period_id", element: <IslamicEditAttendance />, requiredPositions: [50, 99] },
  // สถิติการเช็คชื่อ — เข้าได้ทั้งจากเมนู (ยังไม่เลือกวิชา) และจากปุ่มในหน้ารายวิชาของฉัน
  { path: "islamic/attendance-statistic",                element: <IslamicAttendanceStatistic />, requiredPositions: [50, 99] },
  { path: "islamic/attendance-statistic/:is_teachId",    element: <IslamicAttendanceStatistic />, requiredPositions: [50, 99] },
  { path: "islamic/score-entry/:is_teachId",             element: <IslamicScoreEntry />,       requiredPositions: [50, 99] },

  // Teaching — management (pos 53, 99)
  { path: "islamic/manage-teaching",                     element: <IslamicManageTeaching />,   requiredPositions: [53, 99] },
  { path: "islamic/timetable-editor",                    element: <IslamicTimetableEditor />,  requiredPositions: [53, 99] },
  { path: "islamic/teacher-timetable",                   element: <IslamicTeacherTimetable />, requiredPositions: [53, 99] },
  { path: "islamic/teaching-tracking",                        element: <IslamicTeachingTracking />,   requiredPositions: [53, 99] },
  { path: "islamic/list-teach-tracking/:is_teachId",          element: <IslamicListTeachTracking />,  requiredPositions: [53, 99] },

  // Assessment (pos 54)
  { path: "islamic/grades",                              element: <IslamicClassGrade />,      requiredPositions: [50, 99] },

  // Advisor (pos 51)
  { path: "islamic/advisor/home",     element: <IslamicAdvisorHome />,     requiredPositions: [51, 99] },
  { path: "islamic/advisor/students", element: <IslamicAdvisorStudents />, requiredPositions: [51, 99] },
  { path: "islamic/advisor/timetable", element: <IslamicAdvisorTimetable />, requiredPositions: [51, 99] },
  { path: "islamic/advisor/dormitory", element: <IslamicAdvisorDormitory />, requiredPositions: [51, 99] },
  { path: "islamic/advisor/leave",    element: <IslamicAdvisorLeave />,    requiredPositions: [51, 99] },
  { path: "islamic/advisor/grades",   element: <IslamicAdvisorGrade />,    requiredPositions: [51, 99] },

  // ติดตามนักเรียนภาคศาสนา — ครูประจำชั้นศาสนา (51) เห็นเฉพาะห้องตน / หัวหน้าระดับ
  // (54 ตอนต้น, 55 ตอนกลาง, 56 ตอนปลาย, 58 AIP, 59 STP) เห็นเฉพาะระดับของตน /
  // หัวหน้าวิชาการศาสนา (57) เห็นทั้งภาคแต่ติ๊กขั้นตอนดูแลไม่ได้ — บังคับที่ server
  // ด้วย attachIslamicTrackingScope + islamicCareActionModel.canTickStep
  { path: "islamic/student-tracking",             element: <IslamicStudentTracking />,       requiredPositions: [51, 54, 55, 56, 57, 58, 59, 99] },
  { path: "islamic/student-tracking/:studentID",  element: <IslamicStudentTrackingDetail />, requiredPositions: [51, 54, 55, 56, 57, 58, 59, 99] },
  { path: "islamic/care-tracking",                element: <IslamicCareTracking />,          requiredPositions: [51, 54, 55, 56, 57, 58, 59, 99] },

  // วิชาการภาคศาสนา — หัวหน้าวิชาการศาสนา (57) และ admin (99) เท่านั้น อ่านอย่างเดียว
  // ฝั่ง server ใช้ attachIslamicTrackingScope อยู่แล้ว จึงเปิดให้หัวหน้าระดับภายหลังได้
  // โดยไม่ต้องแก้โมเดล (ดู server/routes/islamicAcademicRoute.js)
  { path: "islamic/academic/absence-monitor",   element: <IslamicAbsenceMonitor />,   requiredPositions: [57, 99] },
  { path: "islamic/academic/attendance",        element: <IslamicAttendanceReport />, requiredPositions: [57, 99] },
  { path: "islamic/academic/attendance-individual", element: <IslamicAttendanceIndividual />, requiredPositions: [57, 99] },
  { path: "islamic/academic/students-on-leave", element: <IslamicStudentsOnLeave />,  requiredPositions: [57, 99] },
  { path: "islamic/academic/student-list",      element: <IslamicStudentListByRoom />, requiredPositions: [57, 99] },
  { path: "islamic/academic/advisor-tasks",     element: <IslamicAdvisorTasks />,     requiredPositions: [57, 99] },
];

export default protectedRoutes;
